import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { ViInputStandaloneComponent } from '../../../../../../projects/ui/components/input/input-standalone.component';
import { ServiceTicketStore } from '../../../../../@store/service-ticket';
import { CommonStandaloneModule } from '../../../../common-standalone.module';
import { GTMService } from '../../../../services';
import { Subject } from 'rxjs';
import { debounceTime, take, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-service-ticket-other-error-code-field',
  standalone: true,
  imports: [CommonStandaloneModule, ViInputStandaloneComponent],
  templateUrl: './service-ticket-other-error-code-field.component.html',
  styleUrls: ['./service-ticket-other-error-code-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceTicketOtherErrorCodeFieldComponent implements OnInit, OnDestroy {
  otherErrorCodeValue: string;

  valueChanged$ = new Subject<string>();

  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(public serviceTicketStore: ServiceTicketStore, public gtmService: GTMService) {}

  ngOnInit(): void {
    this.valueChanged$
      .pipe(debounceTime(1000), takeUntil(this.ngUnsubscribe$))
      .subscribe((value) => {
        this.onInputValueChange(value);
      });

    this.serviceTicketStore.errorCodes$.pipe(take(1)).subscribe((errorCodes) => {
      if (!!errorCodes.otherErrorCode) {
        this.otherErrorCodeValue = errorCodes.otherErrorCode;
      }
    });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  private onInputValueChange(inputValue: string): void {
    this.serviceTicketStore.updateOtherErrorCode(inputValue.trim());
  }
}
